import { createStore } from "redux";
import rootReducer from "./reducers";

const store = createStore(rootReducer);
// 监听state改变，并持久化

export default store;
